<template>
  <div>
    <Statistics/>
  </div>
</template>

<script>
import Statistics from "./statistics/Statistics.vue";

export default {
  components: {Statistics},
};
</script>

<style></style>
